export default "__VITE_ASSET__XKj25qxR__"